<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(createPriceList)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Registrar lista de precios</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errors">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                        </ul>
                    </b-alert>
                    <b-row>        
                        <b-col cols="12" md="6">
                            <ValidationProvider name="codigo" rules="required|min:1" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Código:">
                                    <b-form-input
                                        v-model="create.codigo"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el código"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nombre:">
                                    <b-form-input
                                        v-model="create.nombre"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Registrar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
    
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            errors: "",
            create: {
                codigo: '',
                nombre: '',
                status: true
            },
        }
    },
    methods:{
        ...mapMutations(['setLoading']),
        async createPriceList(){
            this.setLoading(true)
            this.errors = "";
            await this.$conectar.post('/empresa/price-list/save-price-list', this.create)
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error == false){
                    this.$bvToast.toast('Se guardo correctamente la lista de precios', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'getPriceListEmpresa' });
                }
                
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        }

        
    }
}
</script>